import { Injectable } from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class EvaluationService {

  constructor(private commonService: CommonService) { }

  async fetchFactors() {
    return await this.commonService.getSimpleList(`evaluation/factors`);
  }
  async updateFactors(factors: any) {
    return await this.commonService.updateObject(`evaluation/factors`, factors);
  }

  async fetchRefrigeratorDetails(recordId: number) {
    return await this.commonService.getSimpleList(`evaluation/refrigerator/${recordId}`);
  }
}
